import { useEffect, useState } from 'react';
import { getImageFromCache, saveImageToCache } from "utils";
import './CoinFlip.scss';

const CoinFlip = () => {
  const [loading, setLoading] = useState(false);
  const [headsUrl, setHeadsUrl] = useState(null);
  const [tailsUrl, setTailsUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);

    const loadImage = async (fileName, setUrl) => {
      // Try cache first
      const cachedBlob = await getImageFromCache(fileName);
      if (cachedBlob) {
        setUrl(URL.createObjectURL(cachedBlob));
        return;
      }

      // Fetch signed URL from backend
      const res = await fetch( `${process.env.REACT_APP_BACKEND_URL}/get-file-url?fileName=${fileName}` );
      if (!res.ok) throw new Error(`Failed to fetch ${fileName} URL`);
      const { url } = await res.json();

      // Fetch actual image blob
      const imgRes = await fetch(url);
      if (!imgRes.ok) throw new Error(`Failed to fetch ${fileName} blob`);

      const blob = await imgRes.blob();

      // Save to cache & set local object URL
      await saveImageToCache(fileName, blob);
      setUrl(URL.createObjectURL(blob));
    };

    const loadImages = async () => {
      try {
        await Promise.all([
          loadImage("coin-heads.png", setHeadsUrl),
          loadImage("coin-tails.png", setTailsUrl)
        ]);
      } catch (err) {
        console.error("Error fetching image:", err);
        setError("Could not load images");
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, []);

  const flipCoin = () => {
    const coin = document.getElementById("coin");
    if (!coin) return;
    coin.classList.remove("heads", "tails");
    setTimeout(() => {
      coin.classList.add(Math.random() <= 0.5 ? "heads" : "tails");
    }, 100);
  };

  return (
    <div className="coin-flip">
      <div className="coin-flip__shadow"></div>
      {error && <p className="error">{error}</p>}
      <div id="coin" onClick={flipCoin}>
        {(loading || !headsUrl || !tailsUrl)
          ? <div className='coin-flip__loading'>?</div>
          : (
            <>
              <div className="side-a" style={{ backgroundImage: `url("${headsUrl}")` }}></div>
              <div className="side-b" style={{ backgroundImage: `url("${tailsUrl}")` }}></div>
            </>
          )
        }
      </div>
    </div>
  );
};

export default CoinFlip;
